import styled from 'styled-components'
import { Icon } from 'antd'

const AntIconStyled = styled(Icon)``

export default AntIconStyled
